import Vue from 'vue'
import VueRouter from 'vue-router'
import Start from '../views/Start.vue'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Start', component: Start },
  { path: '/home', name: 'Home', component: Home }
]

const router = new VueRouter({
  mode: 'history', // 去掉url中的#
  routes
})

export default router